import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalHelpComponent } from 'src/app/shared/modal-help/modal-help.component';
import { IncidentDetailsResponse } from '../../incident-models';
import { SlicePipe } from '@angular/common';
import { TranslateIncidentStatusEnumPipe } from '../../../../shared/pipes/translate-incident-status-enum.pipe';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'adm-incident-list-details',
  templateUrl: './incident-list-details.component.html',
  styleUrls: ['./incident-list-details.component.scss'],
  imports: [SlicePipe, TranslateIncidentStatusEnumPipe, CommonModule, MatIconModule, MatTooltipModule],
})
export class IncidentListDetailsComponent {
  dialog = inject(MatDialog);

  @Input() incidentDetails: IncidentDetailsResponse;

  openOverflowText(overflowText) {
    this.dialog.open(ModalHelpComponent, {
      data: {
        title: 'Ændring',
        text: overflowText,
      },
    });
  }
}
